import { useState } from "react";
import NavBar from "./NavBar/NavBar";
import Logo from "../Logo/Logo";
import "./Header.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header>
        <div className="header-container">
          <div className="header-left">
            <Logo />
          </div>

          <div className="header-right desktop-only">
            <NavBar />
          </div>

          <button
            className={"mobile-menu-toggle mobile-only" + (menuOpen ? " is-open" : "")}
            aria-label="Menü öffnen/schließen"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>

      <div className={"mobile-menu" + (menuOpen ? " is-open" : "")}>
        <div className="mobile-menu-title">
            Menü
        </div>

       <button
            className="mobile-menu-close"
            aria-label="Menü schließen"
            onClick={() => setMenuOpen(false)}
            >
            <span />
            <span />
        </button>

        <NavBar onClickLink={() => setMenuOpen(false)} />
        </div>


      {menuOpen && (
        <div className="menu-backdrop" onClick={() => setMenuOpen(false)} />
      )}
    </>
  );
}

export default Header;
